import DirectHighSpeedImage from "public/advance-network/direct-high-speed.svg";
import SuperChargedNetworkImage from "public/advance-network/super-charged-network.webp";
import HighPerformanceCPUImage from "public/advance-network/high-performance-cpu.webp";
import NetworkSecurityImage from "public/advance-network/network-security.svg";
import NvmeSsdImage from "public/advance-network/nvme-ssd.svg";
import NativeCoreNetworkImage from "public/advance-network/native-core-network.webp";
import HighSpeedBackupImage from "public/advance-network/high-speed-backup.webp";

export const ADVANCE_NETWORK_CARD_DATA = [
  {
    title: "Direct connect with Any Cloud Provider",
    image: DirectHighSpeedImage,
    test: "opt1",
  },
  {
    title: "Super Charged IP Network",
    image: SuperChargedNetworkImage,
    test: "opt2",
  },
  {
    title: "High Performance Intel CPUs",
    image: HighPerformanceCPUImage,
    test: "opt3",
  },
  { title: "Native DDOS Protection", image: NetworkSecurityImage, test: "opt4" },
  { title: "100% SSD/NVME", image: NvmeSsdImage, test: "opt5" },
  {
    title: "40Gbps Native Core Network",
    image: NativeCoreNetworkImage,
    test: "opt6",
  },
  {
    title: "High Speed Backups and Restore with VEEAM",
    image: HighSpeedBackupImage,
    test: "opt7",
  },
];
